// extracted by mini-css-extract-plugin
export default {"benefitImage":"LP42Ee"};